import { Badge, Card, DataList, Heading, Table, Text } from '@radix-ui/themes'

import { formatCurrency, formatIsoToDDMMYYYY } from '../utils/utils'
import Deal from '../interfaces/Deal'

interface AutoFinHistoryProps {
  autofin: Deal['autofin']
}

const getStatusColor = (status: string | undefined): 'green' | 'red' | 'blue' | 'yellow' | 'gray' => {
  if (!status) return 'gray'
  const s = status.toUpperCase()

  if (s.includes('APROBADO')) return 'green'

  if (s.includes('RECHAZADO') || s.includes('CANCELADO')) return 'red'

  if (s.includes('PENDIENTE') || s.includes('PROCESO') || s.includes('EVALUACION')) return 'yellow'

  return 'blue'
}

export const AutoFinHistory = ({ autofin }: AutoFinHistoryProps) => {
  if (!autofin) return null

  const hasHistory = autofin.history && autofin.history.length > 0
  const hasDetails = autofin.ValorCuota || autofin.EstadoEvaluacion || autofin.status

  // Determine latest status and details
  const latestHistoryItem = hasHistory ? autofin.history![autofin.history!.length - 1] : null
  const latestStatus = latestHistoryItem ? latestHistoryItem.status : autofin.EstadoEvaluacion || autofin.status

  if (!hasHistory && !hasDetails) return null

  return (
    <Card mt="4">
      <Heading size="4" mb="4">
        Evaluación AutoFin
      </Heading>

      {hasDetails && (
        <DataList.Root mb="4">
          <DataList.Item>
            <DataList.Label>Estado</DataList.Label>
            <DataList.Value>
              <Badge color={getStatusColor(latestStatus)}>{latestStatus || 'Pendiente'}</Badge>
            </DataList.Value>
          </DataList.Item>

          {autofin.ValorCuota && (
            <DataList.Item>
              <DataList.Label>Valor Cuota</DataList.Label>
              <DataList.Value>{formatCurrency(autofin.ValorCuota)}</DataList.Value>
            </DataList.Item>
          )}

          {autofin.Pie && (
            <DataList.Item>
              <DataList.Label>Pie</DataList.Label>
              <DataList.Value>{formatCurrency(autofin.Pie)}</DataList.Value>
            </DataList.Item>
          )}

          {autofin.Plazo && (
            <DataList.Item>
              <DataList.Label>Plazo</DataList.Label>
              <DataList.Value>{autofin.Plazo} cuotas</DataList.Value>
            </DataList.Item>
          )}

          {autofin.PrecioVehiculo && (
            <DataList.Item>
              <DataList.Label>Precio Vehículo</DataList.Label>
              <DataList.Value>{formatCurrency(autofin.PrecioVehiculo)}</DataList.Value>
            </DataList.Item>
          )}

          {autofin.CAE && (
            <DataList.Item>
              <DataList.Label>CAE</DataList.Label>
              <DataList.Value>{autofin.CAE}</DataList.Value>
            </DataList.Item>
          )}
          {autofin.lastUpdate && (
            <DataList.Item>
              <DataList.Label>Última actualización</DataList.Label>
              <DataList.Value>{formatIsoToDDMMYYYY(autofin.lastUpdate.toString())}</DataList.Value>
            </DataList.Item>
          )}
        </DataList.Root>
      )}

      {hasHistory && (
        <>
          <Heading size="3" mb="2">
            Historial
          </Heading>
          <Table.Root>
            <Table.Header>
              <Table.Row>
                <Table.ColumnHeaderCell>Fecha</Table.ColumnHeaderCell>
                <Table.ColumnHeaderCell>Estado</Table.ColumnHeaderCell>
                <Table.ColumnHeaderCell>Motivo</Table.ColumnHeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {autofin.history?.map((item, index) => (
                <Table.Row key={index}>
                  <Table.Cell>{formatIsoToDDMMYYYY(item.date.toString())}</Table.Cell>
                  <Table.Cell>
                    <Badge color={getStatusColor(item.status)}>{item.status}</Badge>
                  </Table.Cell>
                  <Table.Cell>
                    <Text size="1">{item.details || '-'}</Text>
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table.Root>
        </>
      )}
    </Card>
  )
}
